/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsMonitor: {
  name: 'monitor';
  data: string;
} = {
  name: 'monitor',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M.5 3A1.5 1.5 0 0 1 2 1.5h12A1.5 1.5 0 0 1 15.5 3v7a1.5 1.5 0 0 1-1.5 1.5H8.5v2H11a.5.5 0 0 1 0 1H5a.5.5 0 0 1 0-1h2.5v-2H2A1.5 1.5 0 0 1 .5 10V3ZM14 10.5H2a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5Z" fill="currentColor"/></svg>`,
};
